// import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { AfterContentChecked, AfterViewInit, Component,Output,EventEmitter ,Input, OnChanges, OnInit, SimpleChanges,Renderer2, ChangeDetectorRef, OnDestroy} from '@angular/core';
import { ColDef, ColumnPanelItemDragEndEvent, GridApi, GridReadyEvent, IRowDragItem, RowDragEndEvent, RowDragMoveEvent } from 'ag-grid-community';
import { NotifierService } from 'angular-notifier';
import { ExcelViewerService } from 'src/app/repository/service/excel-viewer.service';
import { RepoApiService } from 'src/app/repository/service/repo-api.service';
// import '@simonwep/pickr/dist/themes/nano.min.css';
// import Pickr from '@simonwep/pickr';


@Component({
  selector: 'app-kpigrid',
  templateUrl: './kpigrid.component.html',
  styleUrls: ['./kpigrid.component.scss']
})
export class KpigridComponent implements OnInit, OnDestroy {
  [x: string]: any;
  @Input() kpi: any ={};
  @Input() kpi_id: any ={};
  // @Input() tab:any = {data:[],headers:[]};
  public tab:any = {data:[],headers:[]};
  public agGridData:any[] = [];
  public headGroupJson: any = [];
  public headEntryJson: any = [];
  public headParents: any = [];
  public headParentPath: any = [];
  public gridBodyJson: any = [];
  public kpiRowsLocal:any[] = [];
  public prevHoverElement:any = {};
  public currentElement:any;
  public copy_CurrentElement:any;
  public currentElementCol:any;
  public greyColorContainer:any = [];
  // public currentHoverParams:any;


  constructor(
    private notifier:NotifierService,
    public evService:ExcelViewerService,
    private repoService:RepoApiService,
    private readonly renderer: Renderer2,
    public cdr:ChangeDetectorRef,
    ) {}
  ngOnInit(): void {
    this.parseGridJson();
    this.prevHoverElement = {...this.evService.prevHoverElement};
    this.evService.initKpiDetails(this.kpi,this.tab);
    this.selectedKpiId = this.kpi['kpiDetails'].kpi.kpi_id;
    // this.addIconsForRemoveandAdd();
  }
  ngOnDestroy(): void {
    this.gridApi = null;
  }
  parseGridJson(){
    this.agGridData = [];
        this.headGroupJson = [];
        this.headParents = [];
        this.headParentPath = [];
        this.gridBodyJson = [];
        this.greyColorContainer = [];
        this.evService.topCutLevelContainer = {};
        this.headEntryJson = this.headGroupJson;
        this.headEntryJson.push({ 
          headerName: '', 
          children: [
            { 
              field: 'rows',
              rowDrag: true,
              headerName: '', 
              resizable: true, 
              pinned: 'left', 
              tooltipField: 'rows', 
              minWidth: 150, 
              // suppressMovable: true,
              lockPosition: 'left',
              // editable:true,
              // onCellValueChanged:(params) =>{
              //   this.handleCellValueChanged(params);
              // },
              cellStyle:(params) => {
                return this.addCellStyle(params);
              },
            }
          ],
        });

        this.headerTraverser(this.kpi['header']);
        // console.log("this.kpi ====> ",this.kpi);
        this.gridBodyJson = this.gridBodyParser(this.kpi);
        if (this.gridBodyJson && this.gridBodyJson[0] && ("priority" in this.gridBodyJson[0])) {
          // this.gridBodyJson = this.gridBodyJson.sort((a,b) => { return a.priority > b.priority ? 1 : -1})
          this.gridBodyJson = this.gridBodyJson.sort((a,b) => { return a.priority > b.priority ? 1 : (a.priority == b.priority && b.custom) ? 1 : -1})
        }
        this.agGridData.push({ "headers": this.headGroupJson, "data": this.gridBodyJson});
        this.tab = this.agGridData[0];
  }




  addIconsForRemoveandAdd(){
    setTimeout(() =>{
      const header:any = document.querySelectorAll(`.kpiGridCustom_${this.selectedKpiId} .ag-header-row .ag-header-group-cell`);
      // console.log(header);
      header.forEach(parent => {
        let child = parent.children[1];
        let subChild =  child.children[0] as HTMLElement;
        let headerText = subChild.innerText;
        if(headerText){
          let addSection = this.renderer.createElement("div");
          let addTopCutIcons = this.renderer.createElement('img');
          this.renderer.setAttribute(addTopCutIcons,'src','assets/repository/icons/addtopline.png');
          this.renderer.setAttribute(addTopCutIcons,'title','Add Topcut');
          this.renderer.listen(addTopCutIcons,'click',(event) => this.openAddTopcutPopup(event,parent,headerText));
          let removeTopCutIcons = this.renderer.createElement('img');
          this.renderer.setAttribute(removeTopCutIcons,'src','assets/repository/icons/removetopline.png');
          this.renderer.setAttribute(removeTopCutIcons,'title','Remove Topcut');
          this.renderer.listen(removeTopCutIcons,'click',(event) => this.openRemoveTopcutPopup(event,parent,headerText));
          this.renderer.appendChild(addSection,addTopCutIcons);
          this.renderer.appendChild(addSection,removeTopCutIcons);
          let className = `addOrRemoveTopCutSection_${this.selectedKpiId} addOrRemoveTopCutSection`;
          this.renderer.setAttribute(addSection,'class',className);
          this.renderer.appendChild(child,addSection);
          this.renderer.listen(child,'mouseenter',(event) => this.showaddANDRemoveIcons(event,addSection));
          this.renderer.listen(child,'mouseleave',(event) => this.hideaddANDRemoveIcons(event,addSection));
        }
      });
    },10)
  }



  handleCellValueChanged(event){
    this.evService.openKpiGridRowNameEditComponentDialog(event);
  }


  openRemoveTopcutPopup(event,parent,headerText){
    if(parent.classList.length){
      parent.classList.forEach((cls) => {
        // console.log(cls);
        if(cls && cls.includes('pPath_$_')){
          let real_cls = cls.replace('pPath_$_',"");
          if(real_cls){
            setTimeout(() =>{
              let arr = real_cls.split('$');
              let arr_length = arr.length - 1;
              this.evService.openRemoveTopcutPopup(event,headerText,arr_length);
            },10)
          }
          return;
        }
      })
    }
  }



  openAddTopcutPopup(event,parent,headerText){
    if(parent.classList.length){
      parent.classList.forEach((cls) => {
        // console.log(cls);
        if(cls && cls.includes('pPath_$_')){
          let real_cls = cls.replace('pPath_$_',"");
          if(real_cls){
            setTimeout(() =>{
              let arr = real_cls.split('$');
              let arr_length = arr.length - 1;
              this.evService.openAddTopcutPopup(event,headerText,arr_length);
            },10)
          }
          return;
        }
      })
    }
  }


 



  headerTraverser(obj: any) {
    var item = {};
    Object.keys(obj).forEach((element, index) => {
        item = obj[element];
        if (item['type'] && item['type'] == 'level') {
          // if(!item['delete']){
            let temp = {
              // index:index,
              headerKey: element,
              headerName: item['delete'] ? '' : item['name'],
              headerTooltip: item['delete'] ? '' : item['name'],
              marryChildren: true,
              children: [],
              // headerClass:'1234'
              // cellStyle:(params) => {
              //   console.log('Header->>>>>>',params);
              // }
            }
            if (!(item['options'][Object.keys(item['options'])[0]].type == 'option')){
              this.headParents.push(element);
            }
            let pPath = '';
            this.headParentPath.forEach((path,index) => {
              pPath += path + '$'
            });
            pPath += element;
            this.headParentPath.push(element);
            pPath = pPath.replace(/[\])}.[{(]/g, '');
            // temp['headerClass'] = 'pPath_$_' + pPath + ' _$_uuid_$_'+element+'_'+item['name'];
            temp['headerClass'] = 'pPath_$_' + pPath;
            this.headEntryJson.push(temp);
            this.headEntryJson = this.headEntryJson[this.headEntryJson.length - 1].children;
            if(!this.evService.topCutLevelContainer['level_'+(this.headParentPath.length-1)]){
              this.evService.topCutLevelContainer['level_'+(this.headParentPath.length-1)] = [];
            }
            // let topcut_item = {...item,'uuid':element};
            this.evService.topCutLevelContainer['level_'+(this.headParentPath.length-1)].push(item);
            this.headerTraverser(item['options'])

          // }
        } else {
          // if (!(item['show'] == false)) {
            let pPath = '';
            this.headParentPath.forEach(path => {
                pPath += path + '$'
            });
            pPath += element;
            pPath = pPath.replace(/[\])}.[{(]/g, '');
            this.globalvalueformatersigtest = pPath;
            this.headEntryJson.push({ 
              // index:index,
              field: pPath, 
              headerClass:'pPath_$_' + pPath,
              headerKey: item['name'], 
              headerName: item['name'], 
              headerTooltip: item['name'], 
              resizable: true, 
              autoHeight: true,
              wrapText: false,
              minWidth: 90, 
              tooltipField:pPath + ' toolTip',
              // suppressMovable: true,
              cellStyle:(params) => {
                return this.addCellStyle(params,pPath);
              },
              cellClass:(params) =>{
                return this.addCellClass(params,pPath);
              }
             
             
            })
            
          // }
        }
    });
    this.headEntryJson = this.headGroupJson;
    if (item['type'] == 'level') {
        this.headParents.pop();
        this.headParentPath = JSON.parse(JSON.stringify(this.headParents));
    } else {
        this.headParentPath.pop();
    }
    for (let i = 0; i < this.headParents.length; i++) {
        // let parent = this.headEntryJson.find(pitem => pitem.headerName == this.headParents[i]);
        let parent = this.headEntryJson.find(pitem => pitem.headerKey == this.headParents[i]);
        if (parent) {
            this.headEntryJson = parent.children;
        }
    }
    return;
  }

  addCellClass(params,pPath){
    let className = "";
    if(params.node.data['rows'] && params.node.data['rows'].startsWith('Base')){

      if(+params.node.data[pPath] <= 40){
        if (params.node.data['rows'].startsWith('Base (unw)')) {
          this.greyColorContainer.push(pPath);
        }
        className += 'lessThan30Base ';
      }
      if(+params.node.data[pPath] > 40 && +params.node.data[pPath] <= 120){
        className += 'lessThan30Base-v2 ';
      }
    }else{
      if(this.greyColorContainer.includes(pPath)){
        className += 'greyColColor'
      }
    }
    return className;
  }

  addCellStyle(params,pPath?){
    let style = {};
    if(params.node.data[pPath + ' C'] && params.node.data[pPath + ' C'] !== ''){
      if(!this.greyColorContainer.includes(pPath)){
        style['background-color'] = params.node.data[pPath + ' C'];
        style['color'] = 'white';
      }
      // style['background-color'] = params.node.data[pPath + ' C'];
      // style['color'] = 'white';
    }
   

    if(params.node.data[pPath + ' text'] && params.node.data[pPath + ' text'] !== ''){
      style['border'] = '1px dashed #4949a1';
    }
    if(params.node.data && params.node.data.style){
      if(params.node.data.style.backGroundColor &&  params.node.data.style.backGroundColor !== ''){
        style['background-color'] = params.node.data.style.backGroundColor;
      }
      if(params.node.data.style.textColor &&  params.node.data.style.textColor !== ''){
        style['color'] = params.node.data.style.textColor;
      }
      else{
        style['color'] = "#121b5a";
      }
    }

    // adding Ftc color
    // console.log("params.node.data[pPath + ' ftc'] ====> ",params.node.data[pPath + ' ftc']);
    if(params.node.data[pPath + ' ftc'] && params.node.data[pPath + ' ftc'] !== ''){
      style['color'] = params.node.data[pPath + ' ftc'];
    }
    
    return style;
  }




  


  

  gridBodyParser(kpi) {
    let arr = []
    let lastParent = ''
    kpi.rows.forEach((row, index) => {
        // let data = { 'rows': row.v, 'priority': row.priority }
        let data = { 'rows': row.v, 'uuid':row.label, 'origin_label':row.origin_label, 'priority':("priority" in row) ? row.priority : index,'style':row.style ? row.style :{},custom:row.custom}
        let blankRowData = {}
        arr.push(data)
        let parents = [];
        let djson = this.kpi['header']
        recursive(this.kpi['header'])
        function recursive(obj) {
            for (let key in obj) {
                var item = obj[key];
                  if (item.type == 'level') {
                      djson = djson.options ? djson.options[key] : djson[key];
                      if (djson) {
                          lastParent = key
                          if (!(item.options[Object.keys(item.options)[0]].type == 'option'))
                              parents.push(key);
                          recursive(item.options);
                      }
                      else {
                          djson = { ...kpi.header };
                          parents = []
                          return
                      }
                  }
                  else {
                        let arr_index = djson.options[key].index;
                        let name = '';
                        parents.map((p, i) => {
                            name += i == 0 || name == '' ? p : '$' + p
                        })
                        name += name == '' ? lastParent : '$' + lastParent 
                        name += name == '' ? key :'$' + key
                        name = name.replace(/[\])}.[{(]/g, '');
                        let color = name + ' C';
                        let tooltip = name + ' toolTip';
                        let ftc = name + ' ftc';
                        arr[arr.length -  1][color] = '';

                        if (kpi.data[arr_index]) {
                          arr[arr.length - 1][name] = kpi.data[arr_index][index].v;
                          arr[arr.length -  1][tooltip] = kpi.data[arr_index][index].v
                          // if(kpi.data[arr_index][index].tooltip && kpi.data[arr_index][index].tooltip != '')
                          // {
                          //   arr[arr.length -  1][tooltip] = `Value = ${arr[arr.length - 1][name]}, Result = ${kpi.data[arr_index][index].tooltip}`;
                          // }
                          if(kpi.data[arr_index][index]['ftc'] && kpi.data[arr_index][index]['ftc'] != '')
                          {
                            arr[arr.length -  1][ftc] = kpi.data[arr_index][index]['ftc'] ;
                          }
                          if(kpi.data[arr_index][index]['color'] && kpi.data[arr_index][index]['color'] != '')
                          {
                            arr[arr.length -  1][color] = kpi.data[arr_index][index]['color'] ;
                          }

                        }
                
                  }
            }
            djson = { ...kpi.header };
            if (item.type == 'level')
                parents.pop()

            parents.map(p => {
                djson = djson.options ? djson.options[p] : djson[p];
            })
            return
        }

        if (Object.keys(blankRowData) && Object.keys(blankRowData).length) {
          arr.push(blankRowData)
        }
    })

    return arr
  }

  onGridReady(params): void {
    if(!this.gridApi) {
        this.gridApi = params.api;
        // this.gridApi.setSuppressRowDrag(false);
    }
    this.gridApi = params.api;
  }

  sizeToFit(): void {
    if(this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  onModelUpdated(params): void {
      if(!this.gridApi) {
          this.gridApi = params.api;
      }
      this.sizeToFit();
  }

  onFirstDataRendered(): void {
    this.sizeToFit();
      // this.gridApi.sizeColumnsToFit();
  }

  onRowDragMove(event: RowDragMoveEvent) {
  }

  onRowDragEnd(event: RowDragEndEvent) {
    var movingNode = event.node;
    var overNode = event.overNode;
    var rowNeedsToMove = movingNode !== overNode;
    if (rowNeedsToMove) {
      // the list of rows we have is data, not row nodes, so extract the data
      var movingData = movingNode.data;
      var overData = overNode!.data;
      var immutableStore: any[] = this.tab.data
      var fromIndex = immutableStore.indexOf(movingData);
      var toIndex = immutableStore.indexOf(overData);
      var newStore = immutableStore.slice();
      moveInArray(newStore, fromIndex, toIndex);
      immutableStore = newStore;
      this.gridApi.setRowData(newStore);
      this.tab.data = newStore;
      // this.gridApi.clearFocusedCell();
      setTimeout(() => {
        this.gridApi.ensureIndexVisible(toIndex,'middle'); 
        this.gridApi.setFocusedCell(toIndex); 
      }, 100);
      this.evService.onSubmit();
    }
    function moveInArray(arr: any[], fromIndex: number, toIndex: number) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    }

  }

  onDragStarted(event){
    // console.log("this.selectedKpiId ===> ",this.selectedKpiId)
  }
  onDragStopped(event){
    let parentClassList = event.target.parentElement.className.split(" ");
    let nodePath = parentClassList.find(item =>{ return item.includes("pPath_$_")})
    nodePath = nodePath.replace('pPath_$_',"");
    let pPathArr = nodePath.split('$');
    let movingNodeKey = pPathArr.splice(-1,1)[0];
    let pPath = pPathArr.join("$");
    // console.log("pPath ===> ",pPath)
    // console.log("event.columnApi.getColumnState() ===> ",event.columnApi.getColumnState())

    let sortedLeveleStates = this.getSortedLeveles(event.columnApi.getColumnState());
    let currentHeaderState = event.columnApi.getColumnState().filter(item =>{return item["colId"].includes(pPath)})
    let toIndex = currentHeaderState.map(item =>{ return item.colId}).indexOf(nodePath);
    let fromIndex = 0;
    let filters = JSON.parse(JSON.stringify(this.kpi.header));
    // console.log("filters ===> ",filters)

    let tempHeader = filters;
    pPathArr.forEach((headerKey, index) => {
      tempHeader = tempHeader[headerKey]["options"]
    });
    fromIndex = ("priority" in tempHeader[movingNodeKey] && tempHeader[movingNodeKey]["priority"] > 0)? tempHeader[movingNodeKey]["priority"] - 1 :Object.keys(tempHeader).indexOf(movingNodeKey)
    if (fromIndex != toIndex) {
      let newFilters = this.setHeaderPriority(filters,sortedLeveleStates,0)
      // console.log("newFilters ==> ",newFilters)
      // // console.log("currentHeaderState ==> ",currentHeaderState)
      // currentHeaderState.forEach((sHeaser, priorityIndex) => {
      //   let key = sHeaser["colId"].split("$");
      //   key = key.splice(-1,1);
      //   // console.log("key ==> ",key)
      //   tempHeader[key]["priority"] = priorityIndex + 1;
      // });
      let body = {"sheet_uuid":this.evService.selectedSheet['key'],"filters":newFilters};
      // console.log("body ==> ",body)
      this.submitColumnReorder(body)
    }
  }

  getSortedLeveles(leefNodes){
    leefNodes = leefNodes.slice(1);
    let headerLevels = {}
    leefNodes.forEach((leef, index) => {
      let parents = leef.colId.split('$');
      parents.forEach((head,hIndex) => {
        headerLevels["level"+hIndex] = headerLevels["level"+hIndex] && headerLevels["level"+hIndex].length ? headerLevels["level"+hIndex] : [];
        let checkDuplicate = headerLevels["level"+hIndex].find(item =>{ return item === head});
        if (!checkDuplicate) {
          headerLevels["level"+hIndex].push(head);
        }
      });
    });
    return headerLevels;
  }

  setHeaderPriority(filters,sortedLeveleStates,level){
    Object.keys(filters).forEach((headKey,hIndex) => {
      if (filters[headKey]["type"] == "level") {
        filters[headKey]["priority"] = sortedLeveleStates['level'+level].indexOf(headKey) + 1;
        this.setHeaderPriority(filters[headKey]["options"],sortedLeveleStates,level+1)
      }else{
        filters[headKey]["priority"] = sortedLeveleStates['level'+level].indexOf(headKey) + 1;
      }
    });
    return filters;
  }

  submitColumnReorder(body){
    this.isLoading = true;
    this.repoService.setKpiColumnPriority(body).subscribe(
      result=>{
        if (result["status"] == 1) {
          this.isLoading = false;
          this.notifier.notify("warning","The reordering will reset on Edit Table");
          if (Number(this.selectedKpiId)) {
            this.evService.setCurrentTableId(Number(this.selectedKpiId))
          }else{
            this.evService.setCurrentTableId(null)
          }
          this.evService.refreshFilterOptions(this.evService.selectedSheet['value']["sheet_id"]);
        }else{
          this.notifier.notify("error","Something went wrong!");
          this.isLoading = false;
        }
      }, error =>{
        this.notifier.notify("error","Something went wrong!");
        this.isLoading = false;
      }
    )
  }

  onCellMouseOver(params) {
    // this.currentHoverParams = params;
    const className = document.querySelector(`.kpiGridCustom_${this.selectedKpiId} .ag-pinned-left-cols-container`);
    let row_Index = +params.node.rowIndex;
    setTimeout(()=>{
      this.getCurrentNode(className.childNodes,row_Index,'row');
      // Prev Code
      // this.getCurrentNode(className.childNodes,row_Index,'row');
      // let comp_id = this.currentElement['attributes'][0];
      // if(!Object.keys(this.prevHoverElement).length){
      //   this.prevHoverElement['comp_id'] = comp_id.value
      //   let id = `kpiGridCustom_${this.selectedKpiId}_hover_row_${comp_id.value}`;
      //   this.getHoverDivContent(params,this.currentElement,id);
      //   this.prevHoverElement['Id'] = id;
      // }else{
      //   let prev_hover_element = document.getElementById(`${this.prevHoverElement['Id']}`);
      //   if(prev_hover_element){
      //     prev_hover_element.parentNode.removeChild(prev_hover_element);
      //   }
      //   if(comp_id.value != +this.prevHoverElement.comp_id){
      //     this.prevHoverElement['comp_id'] = comp_id.value
      //     let id = `kpiGridCustom_${this.selectedKpiId}_hover_row_${comp_id.value}`;
      //     this.getHoverDivContent(params,this.currentElement,id);
      //     this.prevHoverElement['Id'] = id;
      //   }
      // }

      //New Code
      let comp_id = this.currentElement['attributes'][0];
      let id = `kpiGridCustom_${this.selectedKpiId}_hover_row_${comp_id.value}`;
      this.getHoverDivContent(params,this.currentElement,id);
    },10)
  }

  getCurrentNode(node:any,rowIndex:number,type:string){
    if(type === 'row'){
      node.forEach((va:any) =>{
        let row_id = va['attributes'][6]
        let row_index = +row_id.value;
        if(row_index == rowIndex){
          this.currentElement = va;
        }
      })
    }else{
      node.forEach((va:any) =>{
        let row_id = va['attributes'][6]
        let row_index = +row_id.value;
        if(row_index == rowIndex){
          this.currentElementCol = va;
        }
      })
    }
  }

  getHoverDivContent(params,parent,id?){
    params.event.stopPropagation();

    let mainDiv = this.renderer.createElement('div');
    this.renderer.setAttribute(mainDiv,'id',id);

    let hoverDiv = this.renderer.createElement('div');
    this.renderer.addClass(hoverDiv,'hovering_div');

    let bold_element = this.renderer.createElement('img');
    this.renderer.setAttribute(bold_element,'src','assets/repository/icons/bold.png');
    this.renderer.listen(bold_element,'click',(event) => {this.SetBoldtoCurrentRow(params,event)})
    this.renderer.appendChild(hoverDiv,bold_element);


    let italic_element = this.renderer.createElement('img');
    this.renderer.setAttribute(italic_element,'src','assets/repository/icons/italic.png');
    this.renderer.listen(italic_element,'click',(event) => {this.SetItalictoCurrentRow(params,event)})
    this.renderer.appendChild(hoverDiv,italic_element);

    let underline = this.renderer.createElement('img');
    this.renderer.setAttribute(underline,'src','assets/repository/icons/underline.png');
    this.renderer.listen(underline,'click',(event) => {this.SetUnderLinetoCurrentRow(params,event)})
    this.renderer.appendChild(hoverDiv,underline);




    // ----------------------------------------------> Working Code Color Picker <----------------------------------------------------------------//

    // let textcolorIcon = this.renderer.createElement('img');
    // this.renderer.setAttribute(textcolorIcon,'src','assets/repository/icons/textcolor.png');
    // let color_picker = this.renderer.createElement('div');
    // this.renderer.addClass(color_picker,'color-picker');
    // this.renderer.setAttribute(color_picker,'style','opactiy:0')
    // this.renderer.appendChild(textcolorIcon,color_picker);
    // this.renderer.listen(textcolorIcon,'click',(event) => {this.openColorPicker(params,event,'text')});
    // this.renderer.appendChild(hoverDiv,textcolorIcon);



    // let backgroundcolorIcon = this.renderer.createElement('img');
    // this.renderer.setAttribute(backgroundcolorIcon,'src','assets/repository/icons/backgroundcolor.png');
    // let color_pick = this.renderer.createElement('div');
    // this.renderer.addClass(color_pick,'color-picker');
    // this.renderer.setAttribute(color_pick,'style','opactiy:0')
    // this.renderer.appendChild(backgroundcolorIcon,color_picker);
    // this.renderer.listen(backgroundcolorIcon,'click',(event) => {this.openColorPicker(params,event,'bg')});
    // this.renderer.appendChild(hoverDiv,backgroundcolorIcon);


    // let undo = this.renderer.createElement('img');
    // this.renderer.setAttribute(undo,'src','assets/repository/icons/undo.png');
    // this.renderer.listen(undo,'click',(event) => {this.SetRowToDefault(params,event)})
    // this.renderer.appendChild(hoverDiv,undo);

    //  -------------------------------------------> Ends Here ------------------------------------------------------------------------//



    this.renderer.appendChild(mainDiv,hoverDiv)
    this.renderer.appendChild(parent,mainDiv);

    // part Of New Code
    this.renderer.listen(parent,'mouseenter',(event) => this.sideCutHoverDiv(hoverDiv,'show'));
    this.renderer.listen(parent,'mouseleave',(event) => this.sideCutHoverDiv(hoverDiv,'hide'));

  }


  


  sideCutHoverDiv(child,type){
    if(type == 'show'){
      this.renderer.setStyle(child,'display','block');
    }else{
      this.renderer.setStyle(child,'display','none');
    }

  }

  // SetRowToDefault(params,event){
  //   this.copy_CurrentElement = this.currentElement;
  //   this.SetCurrentRowToDefault(params,event)
    
  // }

  // openColorPicker(params,event,type){
  //   this.copy_CurrentElement = this.currentElement;
  //   const pickr = Pickr.create({
  //     el: '.color-picker',
  //     theme: 'nano', // or 'monolith', or 'nano'

  //     swatches: [
  //         'rgba(244, 67, 54, 1)',
  //         'rgba(233, 30, 99, 0.95)',
  //         'rgba(156, 39, 176, 0.9)',
  //         'rgba(103, 58, 183, 0.85)',
  //         'rgba(63, 81, 181, 0.8)',
  //         'rgba(33, 150, 243, 0.75)',
  //         'rgba(3, 169, 244, 0.7)',
  //         'rgba(0, 188, 212, 0.7)',
  //         'rgba(0, 150, 136, 0.75)',
  //         'rgba(76, 175, 80, 0.8)',
  //         'rgba(139, 195, 74, 0.85)',
  //         'rgba(205, 220, 57, 0.9)',
  //         'rgba(255, 235, 59, 0.95)',
  //         'rgba(255, 193, 7, 1)'
  //     ],

  //     components: {

  //         // Main components
  //         preview: true,
  //         opacity: true,
  //         hue: true,

  //         // Input / output Options
  //         interaction: {
  //             hex: true,
  //             rgba: true,
  //             hsla: false,
  //             hsva: false,
  //             cmyk: false,
  //             input: true,
  //             clear: true,
  //             save: true,
  //         }
  //     }
  //   });
  //   pickr.show();
  //   let ele = document.querySelector('.pickr .pcr-button');
  //   this.renderer.setAttribute(ele,'style','display:none');

  //   pickr.on('save',(...args) =>{
  //     let color = args[0].toHEXA();
  //     let hexCode = '#'+color[0]+color[1]+color[2];
  //     if(type === 'bg'){
  //       this.SetBackgroundColorToCurrentRow(params,event,hexCode,pickr);
  //     }else{
  //       this.SetTextColortoCurrentRow(params,event,hexCode,pickr);
  //     }
  //   })
  //   // console.log(ele,'Hurrah');

  // }

  SetBoldtoCurrentRow(params,event){
    event.stopPropagation();
    let current_Row_Details = {'rows':params.data.rows,'priority':params.data.priority,'rowIndex':params.node.rowIndex};
    const className = document.querySelector(`.kpiGridCustom_${this.selectedKpiId} .ag-center-cols-container`);
    setTimeout(()=>{
      this.getCurrentNode(className.childNodes,params.node.rowIndex,'col');
      if(this.currentElementCol){
        this.currentElementCol.classList.add('current-row-bold');
        this.currentElement.classList.add('current-row-bold');
        let json = this.tab.data.find((va) =>{
          return va['rows'] === current_Row_Details['rows'];
        })
        if(json){
          if(json['style']['bold']){
            json['style']['bold'] = false;
            this.currentElementCol.classList.remove('current-row-bold');
            this.currentElement.classList.remove('current-row-bold');
          }else{
            json['style']['bold'] = true;
          }
          this.evService.onSubmit('bold',json);
        }
      }
    },100)
  }

  SetItalictoCurrentRow(params,event){
    event.stopPropagation();
    let current_Row_Details = {'rows':params.data.rows,'priority':params.data.priority,'rowIndex':params.node.rowIndex};
    const className = document.querySelector(`.kpiGridCustom_${this.selectedKpiId} .ag-center-cols-container`);
    setTimeout(()=>{
      this.getCurrentNode(className.childNodes,params.node.rowIndex,'col');
      if(this.currentElementCol){
        this.currentElementCol.classList.add('current-row-Italic');
        this.currentElement.classList.add('current-row-Italic');
        let json = this.tab.data.find((va) =>{
          return va['rows'] === current_Row_Details['rows'];
        })
        if(json){
          if(json['style']['italic']){
            json['style']['italic'] = false;
            this.currentElementCol.classList.remove('current-row-Italic');
            this.currentElement.classList.remove('current-row-Italic');
          }else{
            json['style']['italic'] = true;
          }
          this.evService.onSubmit('italic',json);
        }
      }
    },100)
  }

  SetUnderLinetoCurrentRow(params,event){
    event.stopPropagation();
    let current_Row_Details = {'rows':params.data.rows,'priority':params.data.priority,'rowIndex':params.data.rowIndex};
    const className = document.querySelector(`.kpiGridCustom_${this.selectedKpiId} .ag-center-cols-container`);
    setTimeout(()=>{
      this.getCurrentNode(className.childNodes,params.node.rowIndex,'col');
      if(this.currentElementCol){
        this.currentElementCol.classList.add('current-row-underline');
        this.currentElement.classList.add('current-row-underline');
        let json = this.tab.data.find((va) =>{
          return va['rows'] === current_Row_Details['rows'];
        })
        if(json){
          if(json['style']['underline']){
            json['style']['underline'] = false;
            this.currentElementCol.classList.remove('current-row-underline');
            this.currentElement.classList.remove('current-row-underline');
          }else{
            json['style']['underline'] = true;
          }
          this.evService.onSubmit('underline',json);
        }
      }
    },100)
  }

  // SetTextColortoCurrentRow(params,event,color_value,picker){
  //   event.stopPropagation();
  //   let current_Row_Details = {'rows':params.data.rows,'priority':params.data.priority,'rowIndex':params.node.rowIndex};
  //   const className = document.querySelector(`.kpiGridCustom_${this.selectedKpiId} .ag-center-cols-container`);
  //   setTimeout(()=>{
  //     this.getCurrentNode(className.childNodes,params.node.rowIndex,'col');
  //     if(this.currentElementCol){
  //       let suffix = `${this.selectedKpiId}_${params.data.priority}`;
  //       this.currentElementCol.classList.add('current_row_text');
  //       this.currentElementCol.classList.add(`current_colHeading_text_${suffix}`);
  //       this.copy_CurrentElement.classList.add('current_row_text');
  //       this.copy_CurrentElement.classList.add(`current_rowHeading_text_${suffix}`);
  //       // let color_value:any = document.getElementById(`text-color-input_${suffix}`);
  //       if(color_value){
  //         let span_cell_row = document.querySelector(`.current_rowHeading_text_${suffix} .ag-cell-value`);
  //         if(span_cell_row){
  //           span_cell_row.setAttribute('style',`color:${color_value} !important`);
  //         }
  //         let span_cell_col = document.querySelectorAll(`.current_colHeading_text_${suffix} .ag-cell-value`);
  //         span_cell_col.forEach((va:any) =>{
  //           va.setAttribute('style',`color:${color_value} !important`);
  //         })
  //         // this.currentElementCol.setAttribute('style',`transform:translateY(${42*params.node.rowIndex}px)`);
  //         let json = this.tab.data.find((va) =>{
  //           return va['priority'] === current_Row_Details['priority'];
  //         })
  //         if(json){
  //           if(color_value && color_value){
  //             json['style']['textColor'] = color_value;
  //             this.evService.onSubmit('textColor',json);
  //             picker.hide();
  //           }
  //         }
  //       }
  //     }
  //   },100)
  // }

  // SetBackgroundColorToCurrentRow(params,event,color_value,picker){
  //   event.stopPropagation();
  //   let current_Row_Details = {'rows':params.data.rows,'priority':params.data.priority,'rowIndex':params.node.rowIndex};
  //   const className = document.querySelector(`.kpiGridCustom_${this.selectedKpiId} .ag-center-cols-container`);
  //   setTimeout(()=>{
  //     this.getCurrentNode(className.childNodes,params.node.rowIndex,'col');
  //     if(this.currentElementCol){
  //       let suffix = `${this.selectedKpiId}_${params.data.priority}`;
  //       this.currentElementCol.classList.add('current_row_bgColor');
  //       this.currentElementCol.classList.add(`current_colHeading_bgColor_${suffix}`);
  //       this.copy_CurrentElement.classList.add('current_row_bgColor');
  //       this.copy_CurrentElement.classList.add(`current_rowHeading_bgColor_${suffix}`);
  //       if(color_value){
  //         let span_cell_row = document.querySelector(`.current_rowHeading_bgColor_${suffix} .ag-cell-value`);
  //         if(span_cell_row){
  //           span_cell_row.setAttribute('style',`background-color:${color_value} !important`);
  //         }
  //         let span_cell_col = document.querySelectorAll(`.current_colHeading_bgColor_${suffix} .ag-cell-value`);
  //         span_cell_col.forEach((va:any) =>{
  //           va.setAttribute('style',`background-color:${color_value} !important`);
  //         })
  //         // this.currentElementCol.setAttribute('style',`transform:translateY(${42*params.node.rowIndex}px)`);
  //         let json = this.tab.data.find((va) =>{
  //           return va['priority'] === current_Row_Details['priority'];
  //         })
  //         if(json){
  //           if(color_value && color_value){
  //             json['style']['backGroundColor'] = color_value;
  //             this.evService.onSubmit('backGroundColor',json);
  //             picker.hide();
  //           }
  //         }
  //       }
  //     }
  //   },100)
  // }

  // SetCurrentRowToDefault(params,event){
  //   event.stopPropagation();
  //   let current_Row_Details = {'rows':params.data.rows,'priority':params.data.priority,'rowIndex':params.node.rowIndex};
  //   const className = document.querySelector(`.kpiGridCustom_${this.selectedKpiId} .ag-center-cols-container`);
  //   setTimeout(()=>{
  //     this.getCurrentNode(className.childNodes,params.node.rowIndex,'col');
  //     if(this.currentElementCol){
  //       let suffix = `${this.selectedKpiId}_${params.data.priority}`;
  //       this.currentElementCol.classList.add('current_row_text');
  //       this.currentElementCol.classList.add(`current_colHeading_text_${suffix}`);
  //       this.copy_CurrentElement.classList.add('current_row_text');
  //       this.copy_CurrentElement.classList.add(`current_rowHeading_text_${suffix}`);
  //       let span_cell_row = document.querySelector(`.current_rowHeading_text_${suffix} .ag-cell-value`);
  //       if(span_cell_row){
  //         span_cell_row.setAttribute('style',`color:#121b5a; background-color:#fff`);
  //       }
  //       let span_cell_col = document.querySelectorAll(`.current_colHeading_text_${suffix} .ag-cell-value`);
  //       span_cell_col.forEach((va:any) =>{
  //         va.setAttribute('style',`color:#121b5a; background-color:#fff`);
  //       })
  //       // this.currentElementCol.setAttribute('style',`transform:translateY(${42*params.node.rowIndex}px)`);  
  //       let json = this.tab.data.find((va) =>{
  //         return va['priority'] === current_Row_Details['priority'];
  //       })
  //       if(json){
  //         if(json['style'] && Object.keys(json['style']).length){
  //           if(json['style']['italic']){
  //             this.currentElementCol.classList.remove('current-row-Italic');
  //             this.currentElement.classList.remove('current-row-Italic');
  //           }
  //           if(json['style']['bold']){
  //             this.currentElementCol.classList.remove('current-row-bold');
  //             this.currentElement.classList.remove('current-row-bold');
  //           }
  //           if(json['style']['underline']){
  //             this.currentElementCol.classList.remove('current-row-underline');
  //             this.currentElement.classList.remove('current-row-underline');
  //           }
  //         }
  //         json['style'] = {};
  //         json['style']['textColor'] = '#121b5a';
  //         json['style']['backGroundColor'] = "#fff";
  //         this.evService.onSubmit('default',json);
  //       }
  //     }
  //   },100)

  // }

  rowClassRules = {
    'current-row-bold': function(params) { 
      return params.data && params.data.style && params.data.style['bold'] == true;
    },

    'current-row-Italic': function(params) { 
      return params.data && params.data.style && params.data.style['italic'] == true
    },

    'current-row-underline': function(params) { 
      return params.data && params.data.style && params.data.style['underline'] == true
    },
  };



}
